import React, { useState } from 'react';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { useToast } from '../../components/CustomToast';

function FeedbackPanel() {
  const [feedback, setFeedback] = useState("");
  const [selectedRating, setSelectedRating] = useState(3);
  const db = getFirestore();
  const { addToast } = useToast();

  const handleFeedbackSubmit = async () => {
    if (!feedback) return;
    try {
      await addDoc(collection(db, "feedback"), {
        feedback,
        rating: selectedRating,
        timestamp: new Date()
      });
      addToast("Feedback sendt - mange tak!", "success");
      setFeedback(""); // Clear the feedback input
    } catch (error) {
      console.error("Fejl ved feedback:", error);
      addToast("Fejl ved feedback.", "error");
    }
  };

  return (
    <div className="grow">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        <div>
          <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-4">Giv Feedback anonymt</h2>
          <div className="text-sm">Vores produkt forbedres af bruger feedback, så vi ville blive utroligt glad hvis du ville dele din oplevelse</div>
        </div>

        {/* Rate */}
        <section>
          <h3 className="text-xl leading-snug text-gray-800 dark:text-gray-100 font-bold mb-6">Hvor stor sandsynlighed er der for du ville anbefale os til dine kollegaer eller venner?</h3>
          <div className="w-full max-w-xl">
            <div className="relative">
              <div className="absolute left-0 top-1/2 -mt-px w-full h-0.5 bg-gray-200 dark:bg-gray-700/60" aria-hidden="true"></div>
              <ul className="relative flex justify-between w-full">
                {[1, 2, 3, 4, 5].map((rating) => (
                  <li key={rating} className="flex">
                    <button 
                      onClick={() => setSelectedRating(rating)}
                      className={`w-3 h-3 rounded-full ${
                        selectedRating === rating 
                          ? 'bg-violet-500 border-2 border-violet-500' 
                          : 'bg-white dark:bg-gray-800 border-2 border-gray-400 dark:border-gray-500'
                      }`}
                    >
                      <span className="sr-only">{rating}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="w-full flex justify-between text-sm text-gray-500 dark:text-gray-400 italic mt-3">
              <div>Overhoved ikke</div>
              <div>Helt klart</div>
            </div>
          </div>
        </section>

        {/* Tell us in words */}
        <section>
          <h3 className="text-xl leading-snug text-gray-800 dark:text-gray-100 font-bold mb-5">Beskriv din oplevelse med platformen </h3>
          {/* Form */}
          <label className="sr-only" htmlFor="feedback">Leave a feedback</label>
          <textarea
            id="feedback"
            className="form-textarea w-full focus:border-gray-300"
            rows="4"
            placeholder="Jeg kunne godt tænke mig at..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          ></textarea>
        </section>
      </div>

      {/* Panel footer */}
      <footer>
        <div className="flex flex-col px-6 py-5 border-t border-gray-200 dark:border-gray-700/60">
          <div className="flex self-end">
            <button
              className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white ml-3"
              onClick={handleFeedbackSubmit}
            >
              Indsend feedback
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default FeedbackPanel;